import { Box, Combobox, Heading, Label } from '@zillow/constellation-10';

import RMWInput from '../../../RMWInput';

import type { ConvertableItemType, ConvertableOptionType } from '../types';

type PropertyToConvertProps = {
  convertableList: Array<ConvertableOptionType>;
  handleOptionSelect: (option: ConvertableOptionType) => void;
  selectedItem: ConvertableItemType;
};

const PropertyToConvert = ({ convertableList, handleOptionSelect, selectedItem }: PropertyToConvertProps) => {
  const { floorplanName, unitName } = selectedItem;
  const intialDisplayValue = floorplanName && unitName ? `${floorplanName} (Unit: ${unitName})` : `${floorplanName}`;

  const handleSelect = (option: unknown) => {
    if (typeof option === 'string') return;
    handleOptionSelect(option as ConvertableOptionType);
  };

  return (
    <div data-testid="PropertyToConvert">
      <Box css={{ marginBottom: '400' }}>
        <Heading level={4}>Floor plan/unit</Heading>
      </Box>
      <Box>
        <Label required={true}>Floor plan or unit to convert</Label>
        <Combobox
          value={intialDisplayValue}
          onOptionSelect={handleSelect}
          options={convertableList}
          placeholder="Choose a floor plan or unit"
        />
      </Box>

      <Box css={{ marginBlock: '400', display: 'flex', flexDirection: 'row', gap: '600' }}>
        <RMWInput disabled={true} initialValue={selectedItem.price} label="Price" placeholder="Price" />

        <RMWInput
          disabled={true}
          initialValue={selectedItem.squareFeet}
          label="Square footage"
          placeholder="Square footage"
        />
      </Box>

      <Box css={{ marginBlock: '400', display: 'flex', flexDirection: 'row', gap: '600' }}>
        <RMWInput disabled={true} initialValue={selectedItem.beds} label="Beds" placeholder="Beds" />

        <RMWInput disabled={true} initialValue={selectedItem.baths} label="Baths" placeholder="Baths" />
      </Box>
    </div>
  );
};

export default PropertyToConvert;
